import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Widget } from "@uploadcare/react-widget";
import Icon from './Icon';

const FileUploader = ({ children, isLoading, onChange, className, value, ...rest }) => {

  const widgetRef = useRef()
  const [loading, setLoading] = useState(false)
  
  const handleOpenDialog = (e) => {
    e.preventDefault()
    widgetRef.current.openDialog();
  }

  const handleChange = file => {
    
    onChange(file)
    setLoading(false)
  }

  const handleFileSelect = e => {
    if(e){
      e.progress(uploadInfo => {
        if(uploadInfo.state === 'uploading'){
          setLoading(true)
        }
        if(uploadInfo.state === 'ready'){
          setLoading(false)
        }
      })
    }
  }

  return (
    <>
      <button
      
        disabled={loading || isLoading}
        onClick={handleOpenDialog}
        className={className}
        {...rest}
      >
        {loading || isLoading ? <Icon.Spinner className="animate-spin !text-white"/> : children}
      </button>
      <Widget 
        imagesOnly
        value={value}
        crop="free, 16:9, 4:3, 5:4, 1:1"
        preloader={null}
        onChange={handleChange}
        onFileSelect={handleFileSelect}
        ref={widgetRef} 
        tabs="file camera facebook gdrive url"
        publicKey="96f388cbb70f3be84e4a"
        />
    </>
  )
}

FileUploader.defaultProps = {
  isLoading: false,
  onChange: undefined,
  className: '',
  value: ''
}

FileUploader.propTypes = {
  isLoading: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  value: PropTypes.string,
}

export default FileUploader;